<template>
  <div v-bind:id="uniqueId">
    <div v-show="showLoading">
      <div id="loading-grid">
        <svg
          class="spinner"
          width="65px"
          height="65px"
          viewBox="0 0 66 66"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="path"
            fill="none"
            stroke-width="6"
            stroke-linecap="round"
            cx="33"
            cy="33"
            r="30"
          ></circle>
        </svg>
      </div>
    </div>
    <div :class="tableContainerClasses" v-show="!showLoading">
      <!-- <div class="con-tablex vs-table--content">
        <div class="vs-con-tbody vs-table--tbody"> -->
      <slot class="flex-container"> </slot>

      <!-- <tbody class="list">
              <tr
                v-for="(i, iIndex) in rowItems"
                v-bind:key="iIndex"
                :class="i.__tableRowClass"
              >
                <td v-if="indexRowEnabled" class="text-center">
                  {{
                    (pagination.pageNumber - 1) * pagination.pageSize +
                      iIndex +
                      1
                  }}
                </td>
                <slot :row="i" :index="iIndex">
                  <td
                    v-for="(c, cIndex) in columns"
                    v-bind:key="cIndex"
                    v-html="renderCell(c, i)"
                  ></td>
                </slot>
              </tr>
            </tbody> 
          </table>-->
      <!-- </div>
      </div> -->
    </div>
  </div>
</template>
<style lang="scss">
.flex-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 30px;
  text-align: center;
}

.flex-container > div {
  border: 1px solid black;
  background-color: #f1f1f1;
  padding: 10px;
  flex: 25%;
}

@media (max-width: 992px) {
  .flex-container > div {
    flex: 50%;
  }
}
@media (max-width: 768px) {
  .flex-container > div {
    flex: 100%;
  }
}
</style>
<script>
import { ajax } from "@/plugins/ajax";
import utils from "@/assets/utils/index";
import "../../assets/scss/vuesax-rtl/_grid-style.scss";

export default {
  name: "data-grid",
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    filterrow: {
      type: Array,
      default: () => []
    },
    dataSource: {
      type: Object,
      default: () => ({
        type: "",
        url: "",
        method: "get",
        service: "",
        transform: null,
        data: null
      })
    },
    searchData: {
      type: Object,
      default: () => ({})
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: true
    },
    indexRowEnabled: {
      type: Boolean,
      default: true
    },
    paging: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    tableContainerClasses() {
      var classes = "datagrid vs-component vs-con-table vs-table-primary";
      if (this.striped === true) classes += " stripe";
      if (this.bordered === true) classes += " table-bordered";
      if (this.hover === true) classes += " table-hover";
      return classes;
    }
  },
  data() {
    var uniqueId = "dt_" + utils.randomString(8);
    return {
      uniqueId: uniqueId,
      rowItems: [],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      sortField: "",
      sortType: "",
      showLoading: false,
      backgroundLoading: "#fff",
      colorLoading: "primary",
      errorOccurred: false
    };
  },
  mounted() {
    this.renderGrid();
  },
  methods: {
    renderGrid(pageNo, filter) {
      var self = this;
      if (pageNo && filter) {
        self.pagination.pageNumber = pageNo;
      }
      this.showLoading = true;
      this.getData()
        .then(result => {
          self.rowItems = result;
          self.blockingEnd();
        })
        .catch(() => {
          self.blockingEnd();
        });
    },
    renderCell(columnItem, rowItem) {
      return rowItem[columnItem.field];
    },
    getData() {
      var self = this;
      return new Promise((resolve, reject) => {
        if (this.dataSource) {
          var getDataFromResourcePromise =
            this.dataSource.type == "ajax"
              ? self.getDataFromRemoteService()
              : this.dataSource.type == "app"
              ? self.getDataFromAppService()
              : self.getDataFromLocalArray();
          getDataFromResourcePromise
            .then(result => {
              if (
                this.dataSource.transform &&
                utils.isFunction(this.dataSource.transform)
              )
                result = this.dataSource.transform(result);
              resolve(result);
            })
            .catch(e => {
              reject(e);
            });
        } else {
          reject();
          this.errorOccurred = true;
        }
      });
    },
    getDataFromRemoteService() {
      // var self = this;
      return new Promise((resolve, reject) => {
        ajax[this.dataSource.method](this.dataSource.url)
          .then(r => {
            if (r && r.data) {
              resolve(r.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
            this.errorOccurred = true;
          });
      });
    },
    getDataFromAppService() {
      var self = this;
      var params =
        "?take=" +
        (this.paging ? String(self.pagination.pageSize) : "0") +
        "&skip=" +
        (this.paging
          ? String((self.pagination.pageNumber - 1) * self.pagination.pageSize)
          : "0") +
        //'&sortField=' + self.sortField +
        //'&sortType=' + self.sortType +
        "&" +
        utils.toQueryString(self.searchData);

      return new Promise((resolve, reject) => {
        ajax[self.dataSource.method || "get"](self.dataSource.service + params)
          .then(r => {
            if (r && r.data) {
              self.pagination.total = parseInt(r.data.total);
              resolve(r.data.data);
            } else {
              reject();
            }
          })
          .catch(() => {
            reject();
            this.errorOccurred = true;
          });
      });
    },
    getDataFromLocalArray() {
      return new Promise(resolve => {
        resolve(this.dataSource.data);
      });
    },
    onPageChange() {
      this.renderGrid();
    },

    blockingEnd() {
      this.showLoading = false;
    },
    getPagingTextData() {
      return {
        from:
          this.rowItems && this.rowItems.length > 0
            ? (this.pagination.pageNumber - 1) * this.pagination.pageSize + 1
            : 0,
        to:
          (this.pagination.pageNumber - 1) * this.pagination.pageSize +
          (this.rowItems.length < this.pagination.pageSize
            ? this.rowItems.length
            : this.pagination.pageSize),
        total: this.pagination.total
      };
    },
    sortColumn(col, type) {
      if (col.sort && col.sort.length > 0) {
        this.sortField = col.sort;
        this.sortType = type;
        this.renderGrid();
      }
    }
  }
};
</script>
